import type { GetServerSideProps } from 'next';

import { withFixedPageCommonProps } from '@/utils/fixedPage';

import { getFixedPageStaticProps } from '@/lib/commonPageStaticProps';
import { MyAccountView } from '@/views/MyAccountView';

export const getServerSideProps: GetServerSideProps =
  getFixedPageStaticProps('my-account');
export default withFixedPageCommonProps(MyAccountView);
